<div class="sale-settings">
  <div class="container-fluid p-0">
    <div class="bg-white p-4 mt-1">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-wrap ms-2 me-2">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a routerLink="/sales" class="cursor-pointer">All Sales</a>
                </li>
                <li class="breadcrumb-item active">
                  <a routerLink="/sales/{{ saleId }}" class="cursor-pointer">
                    <i class="fas fa-chevron-right me-2"></i>
                    {{ sale?.saleName }}
                  </a>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                  <i class="fas fa-chevron-right me-2"></i> Sale Settings
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div class="row sale-details ps-2 pe-2">
        <div class="col-md-6 col-sm-12">
          <div class="title-wrap d-sm-flex align-items-center">
            <div class="title-thumb">
              <img
                [src]="sale?.saleImageUrl"
                *ngIf="sale?.saleImageUrl; else placeholder"
                width="60"
              />

              <ng-template #placeholder>
                <img
                  src="assets/images/horse-no-img.jpg"
                  class="default-img"
                  width="60"
                />
              </ng-template>
            </div>
            <div class="sale-title" style="position: relative">
              <h6>{{ sale?.location }}</h6>
              <h1>
                {{ sale?.saleName }}
                <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoaderSale"></i>-->
              </h1>
              <span>{{ sale?.startDate | date : "dd MMM yyyy" }}</span>
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="flex flex-direction-column justify-space-between">
          <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="center"
            color="accent"
          >
            <mat-tab label="General">
              <div class="row mt-4">
                <div class="col-12">
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>SALE TYPE</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <div class="sale-type-label">
                        {{ sale?.saleType }}
                        {{ sale?.isBreezeUpSale ? "Breeze up Sale" : "" }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Accession Prefix</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="accessionPrefix"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Accession Example</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="accessionExample"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Repository Location</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="repositoryLocation"
                      />
                    </div>
                  </div>
                  <!--<div class="row mb-3">
          <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
            <mat-label>X-Ray Template</mat-label>
          </div>
          <div class="col-lg-4 col-sm col-md-6 align-self-center">
            <select formControlName="saleTemplateId" class="form-control">
              <option [value]="0">Select...</option>
              <option
                *ngFor="let saleTemplate of saleTemplates"
                [value]="saleTemplate.saleTemplateId"
              >
                {{ saleTemplate.name }}
              </option>
            </select>
          </div>
        </div>-->
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label
                        >Enforce declaration of client for viewing</mat-label
                      >
                    </div>
                    <div class="col-lg-4 col-sm col-md-3 align-self-center">
                      <mat-checkbox class="me-1" formControlName="xRays">
                        <mat-label class="me-2">X-Rays</mat-label>
                      </mat-checkbox>
                      <mat-checkbox class="me-1" formControlName="scopeVideo">
                        <mat-label class="me-2">Scope Video</mat-label>
                      </mat-checkbox>
                      <mat-checkbox class="me-1" formControlName="pdfReports">
                        <mat-label>PDF Reports</mat-label>
                      </mat-checkbox>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Don't allow scopes to be submitted without X-Rays</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <mat-checkbox class="me-1" formControlName="isXrayRequiredForScopeSubmission">
                        <mat-label class="me-2">Scope submission requires X-Rays</mat-label>
                      </mat-checkbox>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Sale Location TimeZone</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <mat-label class="me-2">{{ model?.timeZone }}</mat-label>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Submission Dates</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <div class="input-group">
                        <input
                          type="text"
                          name="daterange"
                          *ngIf="dateFormat && model?.timeZoneIana"
                          #submissionElement
                          [start]="
                            form.value.submissionDateRange?.getFromDate()
                          "
                          [end]="form.value.submissionDateRange?.getToDate()"
                          [format]="dateFormat"
                          (change)="onSubmissionDate($event)"
                          class="form-control date-range-picker"
                          appDaterangepicker
                        />
                        <button
                          class="btn btn-outline-secondary bi bi-calendar3"
                          (click)="submissionElement.nativeElement.click()"
                          type="button"
                        >
                          <i class="fa fa-calendar"></i>
                        </button>
                      </div>
                      <!--<date-range-picker *ngIf="model?.lotOrHipText"
                     [lotOrHipText]="model?.lotOrHipText"
                     formControlName="submissionDateRange"></date-range-picker>-->
                      <!--<mat-form-field color="accent" class="w-100">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input
                  matStartDate
                  formControlName="submissionStartDate"
                  placeholder="Start date"
                />
                <input
                  matEndDate
                  formControlName="submissionEndDate"
                  placeholder="End date"
                />
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>-->
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>Viewing Dates</mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <div class="input-group">
                        <input
                          type="text"
                          name="dateviewingrange"
                          *ngIf="dateFormat && model?.timeZoneIana"
                          #viewingElement
                          [start]="form.value.viewingDateRange?.getFromDate()"
                          [end]="form.value.viewingDateRange?.getToDate()"
                          [format]="dateFormat"
                          (change)="onViewingDate($event)"
                          class="form-control date-range-picker"
                          appDaterangepicker
                        />
                        <button
                          class="btn btn-outline-secondary bi bi-calendar3"
                          (click)="viewingElement.nativeElement.click()"
                          type="button"
                        >
                          <i class="fa fa-calendar"></i>
                        </button>
                      </div>
                      <!--<date-range-picker *ngIf="model?.lotOrHipText"
                     [lotOrHipText]="model?.lotOrHipText"
                     formControlName="viewingDateRange"></date-range-picker>-->
                      <!--<mat-form-field color="accent" class="w-100">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="picker1">
                <input
                  matStartDate
                  formControlName="viewingStartDate"
                  placeholder="Start date"
                />
                <input
                  matEndDate
                  formControlName="viewingEndDate"
                  placeholder="End date"
                />
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker1></mat-date-range-picker>
            </mat-form-field>-->
                    </div>
                  </div>
                </div>

                <div class="horizontal-rule-one">
                  <hr />
                </div>
              </div>

              <div class="row">
                <h6 class="mb-4 fw-bold">Terms & Policy</h6>
                <div class="col-12">
                  <div class="row mb-2">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>
                        Terms & Conditions<span class="text text-danger"
                          >*</span
                        >
                      </mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="termsAndConditionsUrl"
                        [ngClass]="{
                          'border border-danger':
                            form.get('termsAndConditionsUrl').invalid &&
                            (form.get('termsAndConditionsUrl').dirty ||
                              form.get('termsAndConditionsUrl').touched)
                        }"
                      />

                      <small
                        class="text-danger"
                        *ngIf="
                          submitted &&
                          form.hasError('required', 'termsAndConditionsUrl')
                        "
                      >
                        Terms & Conditions is required!
                      </small>
                      <small
                        class="text-danger"
                        *ngIf="
                          submitted &&
                          !form
                            .get('termsAndConditionsUrl')
                            .hasError('required') &&
                          form.get('termsAndConditionsUrl').invalid
                        "
                      >
                        Please enter a valid URL. It should start with 'http://'
                        or 'https://'
                      </small>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-2 col-sm-6 col-md-2 align-self-center">
                      <mat-label>
                        Privacy Policy<span class="text text-danger">*</span>
                      </mat-label>
                    </div>
                    <div class="col-lg-4 col-sm col-md-6 align-self-center">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="privacyPolicyUrl"
                        [ngClass]="{
                          'border border-danger':
                            form.get('privacyPolicyUrl').invalid &&
                            (form.get('privacyPolicyUrl').dirty ||
                              form.get('privacyPolicyUrl').touched)
                        }"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          submitted &&
                          form.hasError('required', 'privacyPolicyUrl')
                        "
                      >
                        Privacy Policy is required!
                      </small>
                      <small
                        class="text-danger"
                        *ngIf="
                          submitted &&
                          !form.get('privacyPolicyUrl').hasError('required') &&
                          form.get('privacyPolicyUrl').invalid
                        "
                      >
                        Please enter a valid URL. It should start with 'http://'
                        or 'https://'
                      </small>
                    </div>
                  </div>
                </div>
                <div class="horizontal-rule-one">
                  <hr />
                </div>
              </div>

              <div class="row">
                <h6 class="mb-4 fw-bold">New Users Instructions</h6>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="exampleInputViewing" class="form-label"
                      >Viewing</label
                    >
                    <textarea
                      class="form-control w-100"
                      formControlName="newUsersInstructionsViewing"
                      id="exampleInputViewing"
                    ></textarea>
                  </div>

                  <div class="mb-3">
                    <label for="exampleInputSubmittingAStudy" class="form-label"
                      >Submitting a study</label
                    >
                    <textarea
                      class="form-control w-100"
                      formControlName="newUsersInstructionsSubmittingAStudy"
                      id="exampleInputSubmittingAStudy"
                    ></textarea>
                  </div>

                  <div class="mb-3">
                    <label for="exampleInputNotes" class="form-label"
                      >Notes</label
                    >
                    <textarea
                      class="form-control w-100"
                      formControlName="newUsersInstructionsNote"
                      id="exampleInputNotes"
                    ></textarea>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Dates/Deadlines">
              <ng-container *ngIf="!model.isBreezeUpSale; else breezeUpTables">
                <h1 class="mt-5">Sale Dates</h1>
                <div class="row mt-4 mb-3">
                  <label
                    for="inputxrayCommenceDays"
                    class="col-sm-2 col-form-label fw-bold"
                    >Commence Days</label
                  >
                  <div class="col-sm-2">
                    <input
                      type="number"
                      class="form-control"
                      (change)="onDaysChange($event)"
                      formControlName="xrayCommenceDays"
                    />
                  </div>
                </div>
                <div class="data-grid mt-2">
                  <div class="table table-commence-days">
                    <!-- Header Row -->
                    <div class="row mb-2 mat-header-row h-auto">
                      <div class="col-12 col-md-1">
                        <label class="t-heading">Book</label>
                      </div>
                      <div class="col-12 col-md-1">
                        <label class="t-heading">Session</label>
                      </div>
                      <div class="col-12 col-md-2">
                        <label class="t-heading">Sale Date</label>
                      </div>
                      <div class="col-12 col-md-1">
                        <label class="t-heading"
                          >First {{ model?.lotOrHipText }}</label
                        >
                      </div>
                      <div class="col-12 col-md-1">
                        <label class="t-heading"
                          >Last {{ model?.lotOrHipText }}</label
                        >
                      </div>

                      <div class="col-12 col-md-2">
                        <label class="t-heading">X-Ray/Scope Taken</label>
                      </div>
                      <div class="col-12 col-md-2">
                        <label class="t-heading">X-Ray/Scope Visible</label>
                      </div>
                    </div>

                    <!-- Data Rows -->
                    <ng-container formArrayName="saleSession">
                      <div
                        *ngFor="
                          let element of saleSession.controls;
                          let sessionIndex = index
                        "
                        [formGroup]="element"
                        class="row mat-row border-0 h-auto"
                        [ngClass]="{
                          'border-bottom':
                            sessionIndex < saleSession.controls.length - 1
                        }"
                      >
                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["bookNumber"].value }}
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["sessionNumber"].value }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-2">
                          <div class="input-group">
                            <input
                              type="text"
                              name="daterange"
                              *ngIf="dateFormat && model?.timeZoneIana"
                              [start]="element.value.startDate"
                              [end]="element.value.startDate"
                              #startDate
                              [format]="dateFormat"
                              (change)="
                                onSelectDate($event, element, 'startDate')
                              "
                              class="form-control date-range-picker"
                              appDateTimepicker
                            />
                            <button
                              class="btn btn-outline-secondary bi bi-calendar3"
                              (click)="openDatePicker(sessionIndex, startDate)"
                              type="button"
                            >
                              <i class="fa fa-calendar"></i>
                            </button>
                          </div>
                        </div>

                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["minLotNumber"].value }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["maxLotNumber"].value }}
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-2">
                          <div class="input-group">
                            <input
                              type="text"
                              name="daterange"
                              *ngIf="dateFormat && model?.timeZoneIana"
                              [start]="element.value.xrayScopeTaken"
                              [end]="element.value.xrayScopeTaken"
                              #xrayScopeTaken2
                              [format]="dateFormat"
                              (change)="
                                onSelectDate($event, element, 'xrayScopeTaken')
                              "
                              class="form-control date-range-picker"
                              appDateTimepicker
                            />
                            <button
                              class="btn btn-outline-secondary bi bi-calendar3"
                              (click)="
                                openDatePicker(sessionIndex, xrayScopeTaken2)
                              "
                              type="button"
                            >
                              <i class="fa fa-calendar"></i>
                            </button>
                          </div>
                        </div>

                        <div class="col-12 col-md-2">
                          <div class="input-group">
                            <input
                              type="text"
                              name="daterange"
                              *ngIf="dateFormat && model?.timeZoneIana"
                              [start]="element.value.xrayScopeVisible"
                              [end]="element.value.xrayScopeVisible"
                              #xrayScopeVisible2
                              [format]="dateFormat"
                              (change)="
                                onSelectDate(
                                  $event,
                                  element,
                                  'xrayScopeVisible'
                                )
                              "
                              class="form-control date-range-picker"
                              appDateTimepicker
                            />
                            <button
                              class="btn btn-outline-secondary bi bi-calendar3"
                              (click)="
                                openDatePicker(sessionIndex, xrayScopeVisible2)
                              "
                              type="button"
                            >
                              <i class="fa fa-calendar"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Loader -->
                    <!--<div class="col-md-12 text-center" *ngIf="isLoaderSale">
                      Loading <i class="fa fa-spinner fa-spin"></i>
                    </div>-->
                  </div>
                </div>
              </ng-container>

              <ng-template #breezeUpTables>
                <h1 class="mt-5">Sale Dates</h1>
                <div class="data-grid mt-2">
                  <div class="table table-commence-days">
                    <!-- Header Row -->
                    <div class="row mb-2 mat-header-row h-auto">
                      <div class="col-12 col-md-1">
                        <label class="t-heading">Book</label>
                      </div>
                      <div class="col-12 col-md-1">
                        <label class="t-heading">Session</label>
                      </div>

                      <div class="col-12 col-md-2">
                        <label class="t-heading">Sale Date</label>
                      </div>

                      <div class="col-12 col-md-1">
                        <label class="t-heading"
                          >First {{ model?.lotOrHipText }}</label
                        >
                      </div>
                      <div class="col-12 col-md-1">
                        <label class="t-heading"
                          >Last {{ model?.lotOrHipText }}</label
                        >
                      </div>
                    </div>

                    <!-- Data Rows -->
                    <ng-container formArrayName="saleSession">
                      <div
                        *ngFor="
                          let element of saleSession.controls;
                          let sessionIndex = index
                        "
                        [formGroup]="element"
                        class="row mat-row border-0 h-auto"
                        [ngClass]="{
                          'border-bottom':
                            sessionIndex < saleSession.controls.length - 1
                        }"
                      >
                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["bookNumber"].value }}
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["sessionNumber"].value }}
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-2">
                          <div class="t-data"> 
                            {{removeZeroTime(element.controls["endDate"].value)}}
                          </div>
                        </div>

                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["minLotNumber"].value }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-1">
                          <div class="t-data">
                            <div class="box">
                              {{ element.controls["maxLotNumber"].value }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Loader -->
                    <!--<div class="col-md-12 text-center" *ngIf="isLoaderSale">
                      Loading <i class="fa fa-spinner fa-spin"></i>
                    </div>-->
                  </div>
                </div>

                <br />
                <h1>Breeze Up Dates</h1>
                <div class="data-grid mt-2">
                  <div class="table table-commence-days">
                    <!-- Header Row -->
                    <div class="row mb-2 mat-header-row h-auto">
                      <div class="col-11">
                        <div class="row">
                          <div class="col-12 col-md-1">
                            <label class="t-heading">Book</label>
                          </div>
                          <div class="col-12 col-md-1">
                            <label class="t-heading">Session</label>
                          </div>

                          <div class="col-12 col-md-2">
                            <label class="t-heading">Sale Date/Time</label>
                          </div>
                          <div class="col-12 col-md-1">
                            <label class="t-heading"
                              >First {{ model?.lotOrHipText }}</label
                            >
                          </div>
                          <div class="col-12 col-md-1">
                            <label class="t-heading"
                              >Last {{ model?.lotOrHipText }}</label
                            >
                          </div>
                          <div class="col-12 col-md-2">
                            <label class="t-heading">Breeze Date/Time</label>
                          </div>
                          <div class="col-12 col-md-2">
                            <label class="t-heading">X-Ray/Scope Taken</label>
                          </div>
                          <div class="col-12 col-md-2">
                            <label class="t-heading">X-Ray/Scope Visible</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-1">
                        <div class="row">
                          <div class="col-12 col-md-1">
                            <label class="t-heading">Action</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Data Rows -->
                    <ng-container formArrayName="saleBreezeUp">
                      <div
                        *ngFor="
                          let element of saleBreezeUp.controls;
                          let sessionIndex = index
                        "
                        [formGroup]="element"
                        class="row mat-row border-0 h-auto"
                        [ngClass]="{
                          'border-bottom':
                            sessionIndex < saleBreezeUp.controls.length - 1
                        }"
                      >
                        <div class="col-11">
                          <div class="row">
                            <div class="col-12 col-md-1">
                              <div class="t-data">
                                <div class="box">
                                  {{ element.controls["bookNumber"].value }}
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-1">
                              <div class="t-data">
                                <div class="box">
                                  {{ element.controls["sessionNumber"].value }}
                                </div>
                              </div>
                            </div>
                            <!-- Xray scope visible -->
                            <div class="col-12 col-md-2">
                              <div class="input-group">
                                <input
                                  type="text"
                                  name="daterange"
                                  *ngIf="dateFormat && model?.timeZoneIana"
                                  [start]="element.value.saleDateTime"
                                  [end]="element.value.saleDateTime"
                                  #saleDateTime
                                  [format]="dateFormat"
                                  (change)="
                                    onSelectDate(
                                      $event,
                                      element,
                                      'saleDateTime'
                                    )
                                  "
                                  class="form-control date-range-picker"
                                  appDateTimepicker
                                />
                                <button
                                  class="btn btn-outline-secondary bi bi-calendar3"
                                  (click)="
                                    openDatePicker(sessionIndex, saleDateTime)
                                  "
                                  type="button"
                                >
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                            <div class="col-12 col-md-1">
                              <div class="t-data">
                                <div class="box">
                                  {{ element.controls["minLotNumber"].value }}
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-1">
                              <div class="t-data">
                                <div class="box">
                                  {{ element.controls["maxLotNumber"].value }}
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-md-2">
                              <div class="input-group">
                                <input
                                  type="text"
                                  name="daterange"
                                  *ngIf="dateFormat && model?.timeZoneIana"
                                  [start]="element.value.breezeDateTime"
                                  [end]="element.value.breezeDateTime"
                                  #breezeDateTime
                                  [format]="dateFormat"
                                  (change)="
                                    onSelectDate(
                                      $event,
                                      element,
                                      'breezeDateTime'
                                    )
                                  "
                                  class="form-control date-range-picker"
                                  appDateTimepicker
                                />
                                <button
                                  class="btn btn-outline-secondary bi bi-calendar3"
                                  (click)="
                                    openDatePicker(sessionIndex, breezeDateTime)
                                  "
                                  type="button"
                                >
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>

                            <!-- Xray scope taken -->
                            <div class="col-12 col-md-2">
                              <div class="input-group">
                                <input
                                  type="text"
                                  name="daterange"
                                  *ngIf="dateFormat && model?.timeZoneIana"
                                  [start]="element.value.xrayScopeTaken"
                                  [end]="element.value.xrayScopeTaken"
                                  #xrayScopeTaken
                                  [format]="dateFormat"
                                  (change)="
                                    onSelectDate(
                                      $event,
                                      element,
                                      'xrayScopeTaken'
                                    )
                                  "
                                  class="form-control date-range-picker"
                                  appDateTimepicker
                                />
                                <button
                                  class="btn btn-outline-secondary bi bi-calendar3"
                                  (click)="
                                    openDatePicker(sessionIndex, xrayScopeTaken)
                                  "
                                  type="button"
                                >
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                            <!-- Xray scope visible -->
                            <div class="col-12 col-md-2">
                              <div class="input-group">
                                <input
                                  type="text"
                                  name="daterange"
                                  *ngIf="dateFormat && model?.timeZoneIana"
                                  [start]="element.value.xrayScopeVisible"
                                  [end]="element.value.xrayScopeVisible"
                                  #xrayScopeVisible
                                  [format]="dateFormat"
                                  (change)="
                                    onSelectDate(
                                      $event,
                                      element,
                                      'xrayScopeVisible'
                                    )
                                  "
                                  class="form-control date-range-picker"
                                  appDateTimepicker
                                />
                                <button
                                  class="btn btn-outline-secondary bi bi-calendar3"
                                  (click)="
                                    openDatePicker(
                                      sessionIndex,
                                      xrayScopeVisible
                                    )
                                  "
                                  type="button"
                                >
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-1">
                          <div class="t-data">
                            <button
                              type="button"
                              class="btn btn-primary me-1"
                              (click)="editBreezeUpEntry(element)"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger"
                              (click)="deleteBreezeUpEntry(element.value.id)"
                            >
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="openBreezeDateModal()"
                      >
                        + New Breeze Date
                      </button>
                    </ng-container>

                    <!-- Loader -->
                    <!--<div class="col-md-12 text-center" *ngIf="isLoaderSale">
                      Loading <i class="fa fa-spinner fa-spin"></i>
                    </div>-->
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab label="Submissions and Templates">
              <div class="row mt-4">
                <h6 class="mb-4 fw-bold">Required Submissions</h6>
                <div
                  class="col-md-12 salesubmission"
                  formArrayName="saleSubmission"
                >
                  <div class="row border-bottom mb-4 pb-2 salesubmission">
                    <div class="col-md-2">
                      <span>Name</span>
                    </div>

                    <div class="col-md-2">
                      <span>Template</span>
                    </div>
                    <div class="col-md-2">
                      <span>X-Ray Reports</span>
                    </div>
                    <div class="col-md-2">
                      <span>Scope Video</span>
                    </div>
                    <div class="col-md-2">
                      <span>Scope Reports</span>
                    </div>
                    <div class="col-md-2">
                      <span>Auto Approve Submissions</span>
                    </div>
                  </div>
                  <div
                    class="row border-bottom mb-4 pb-2"
                    *ngFor="
                      let submission of saleSubmission.controls;
                      let i = index
                    "
                    [formGroupName]="i"
                    [onInitDirective]="enableCheckboxFields(submission)"
                  >
                    <div class="col-md-2">
                      <mat-checkbox
                        class="me-1"
                        (click)="toggleControl(submission)"
                        formControlName="isActive"
                      >
                        <mat-lable class="text-wrap">
                          {{ submission.value.horseAgeCategoryName }}
                        </mat-lable>
                      </mat-checkbox>
                    </div>
                    <div class="col-md-2">
                      <select
                        formControlName="saleTemplateId"
                        class="form-select w-auto"
                      >
                        <option value="0" disabled>N/A</option>
                        <option
                          *ngFor="let saleTemplate of saleTemplates"
                          [value]="saleTemplate.saleTemplateId"
                        >
                          {{ saleTemplate.name }}
                        </option>
                      </select>
                      <mat-checkbox
                        class="enforce-protocol mt-1"
                        *ngIf="submission.value.saleTemplateId > 0"
                        [checked]="isEnforceProtocol(submission)"
                        [disabled]="submission.controls['xrayCompleteType'].disabled"
                        (change)="setEnforceProtocol(submission, $event.checked)"
                      >
                        <mat-lable class="text-wrap"
                          >Require complete set</mat-lable
                        >
                      </mat-checkbox>
                    </div>
                    <div class="col-md-2">
                      <!--<mat-label class="me-2">X-Rays</mat-label>
                <mat-radio-group aria-label="Select an option"
                                color="accent"
                                formControlName="xrayCompleteType">
                  <mat-radio-button [value]="1" class="me-2">Complete</mat-radio-button>
                  <mat-radio-button [value]="2" class="me-2">Partial</mat-radio-button>
                </mat-radio-group>-->
                      <mat-checkbox class="ms-4" formControlName="isXRayReport">
                      </mat-checkbox>
                    </div>
                    <div class="col-md-2">
                      <mat-checkbox class="ms-4" formControlName="isScope">
                      </mat-checkbox>
                    </div>
                    <div class="col-md-2">
                      <mat-checkbox class="ms-4" formControlName="scopeReport">
                      </mat-checkbox>
                    </div>

                    <div class="col-md-2">
                      <mat-checkbox
                        class="ms-4"
                        formControlName="isAutoApproveSubmissions"
                      >
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <a
                [routerLink]="'/settings'"
                [queryParams]="{ tab: 'template-management' }"
                class="btn btn-link"
                >+ Create new X-Ray Template</a
              >
            </mat-tab>
            <mat-tab label="Sale Documents">
              <div class="row mt-4">
                <h6 class="mb-4 fw-bold">Sale Document Settings</h6>
                <div
                  class="col-md-12 saledocstypes"
                  formArrayName="saleDocumentTypeAccess"
                >
                  <div class="row border-bottom mb-4 pb-2 saledocstypes">
                    <div class="col-md-2">
                      <span>Sale Document</span>
                    </div>

                    <div class="col-md-2">
                      <span>Visible To Vet Viewers</span>
                    </div>
                    <div class="col-md-2">
                      <span>Enforce Open before X-Ray Images</span>
                    </div>
                  </div>
                  <div
                    class="row border-bottom mb-4 pb-2"
                    *ngFor="
                      let docType of saleDocumentTypeAccess.controls;
                      let i = index
                    "
                    [formGroupName]="i"
                  >
                    <div class="col-md-2">
                      <mat-lable class="text-wrap">
                        {{ docType.value.saleDocumentTypeName }}
                      </mat-lable>
                    </div>

                    <div class="col-md-2">
                      <mat-checkbox
                        class="ms-4"
                        formControlName="isVisibleToVetViewer"
                      >
                      </mat-checkbox>
                    </div>

                    <div class="col-md-2">
                      <mat-checkbox
                        class="ms-4"
                        formControlName="isEnforceOpenBeforeXrayImages"
                      >
                      </mat-checkbox>
                    </div>
                  </div>
                </div>

                <div class="horizontal-rule-one">
                  <hr />
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>

          <div class="row">
            <div class="col-md-12 text-end">
              <a routerLink="/sales" class="btn btn-secondary btn-sm me-2">
                <i class="fa fa-times"></i> Cancel
              </a>
              <button type="submit" class="btn btn-primary btn-sm">
                <i class="fa fa-save"></i> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
